import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.set-prototype-of";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';
import Link from '@nerdwallet/react-link';
import LoadingSpinner from '@nerdwallet/react-loading-spinner';
import BackButton from './compare-back-button';
import CompareLink from './compare-link';
import CompareCardImages from './compare-card-images';
import CompareAddButton from './compare-add-button';
import './compare-cta.less';

var CompareCTA =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CompareCTA, _React$Component);

  var _super = _createSuper2(CompareCTA);

  function CompareCTA() {
    _classCallCheck(this, CompareCTA);

    return _super.apply(this, arguments);
  }

  _createClass(CompareCTA, [{
    key: "render",
    value: function render() {
      var _this = this;

      // We do some flex-order reversing based on the value of this.props.showCardImages. This can
      // make the LoadingSpinner appear at the wrong end of the bar. For this reason, there's two
      // instances of the LoadingSpinner in the markup below (although only one is rendered at one
      // time).
      return React.createElement("div", {
        className: "compare-cta"
      }, this.props.showCardImages && this.props.isCompareCardsBusy ? React.createElement("div", {
        className: "compare-cta__spinner-container"
      }, React.createElement(LoadingSpinner, {
        color: "green",
        size: 30
      })) : null, this.props.showCardImages ? React.createElement(CompareCardImages, {
        removeFromCompare: this.props.removeFromCompare,
        cardsToCompare: this.props.cardsToCompare,
        cardIDsToCompare: this.props.cardIDsToCompare
      }) : null, this.props.showAddCard ? React.createElement(CompareAddButton, {
        saveToCompare: this.props.saveToCompare,
        cardsToCompare: this.props.cardsToCompare,
        analytics: this.props.analytics,
        offerSDK: this.props.offerSDK,
        marketplaceSDK: this.props.marketplaceSDK
      }) : null, !this.props.showBackButton || this.props.overrideCTA ? React.createElement(CompareLink, {
        isActive: this.props.numCardsToCompare && this.props.numCardsToCompare > 0,
        numCardsToCompare: this.props.numCardsToCompare,
        buttonClassName: this.props.buttonClassName,
        isLinkToSameApp: this.props.isLinkToSameApp,
        overrideCTA: this.props.overrideCTA,
        ctaText: this.props.ctaText.cta,
        taxonomy: this.props.taxonomy
      }) : null, React.createElement("div", {
        className: "back-reset"
      }, this.props.showBackButton ? React.createElement(BackButton, {
        history: this.props.history
      }) : this.props.numCardsToCompare ? this.props.disableReset ? React.createElement(Link, {
        color: "neutral-lighter",
        className: "reset-link reset-link--no-link"
      }, this.props.ctaText.reset) : React.createElement(ImpressionContext.Consumer, null, function (value) {
        return React.createElement(Link, {
          color: "neutral-darker",
          className: "reset-link",
          onClick: function onClick() {
            return _this.props.clearCompareList(_this.props.analytics.enabled, value === null || value === void 0 ? void 0 : value.impressionId);
          }
        }, _this.props.ctaText.reset);
      }) : null), !this.props.showCardImages && this.props.isCompareCardsBusy ? React.createElement("div", {
        className: "compare-cta__spinner-container"
      }, React.createElement(LoadingSpinner, {
        color: "green",
        size: 30
      })) : null);
    }
  }]);

  return CompareCTA;
}(React.Component);

_defineProperty(CompareCTA, "propTypes", {
  buttonClassName: PropTypes.string,
  cardsToCompare: PropTypes.objectOf(PropTypes.object),
  cardIDsToCompare: PropTypes.arrayOf(PropTypes.number),
  clearCompareList: PropTypes.func.isRequired,
  ctaText: PropTypes.shape({
    cta: PropTypes.string,
    reset: PropTypes.string
  }),
  disableReset: PropTypes.bool,
  analytics: PropTypes.shape({
    enabled: PropTypes.bool,
    payload: PropTypes.shape({
      sectionName: PropTypes.string
    })
  }),
  history: PropTypes.shape({
    goBack: PropTypes.func // eslint-disable-line react/no-unused-prop-types

  }),
  isCompareCardsBusy: PropTypes.bool,
  isLinkToSameApp: PropTypes.bool,
  numCardsToCompare: PropTypes.number,
  offerSDK: PropTypes.shape({}).isRequired,
  overrideCTA: PropTypes.node,
  removeFromCompare: PropTypes.func.isRequired,
  saveToCompare: PropTypes.func.isRequired,
  marketplaceSDK: PropTypes.shape({}).isRequired,
  showAddCard: PropTypes.bool,
  showBackButton: PropTypes.bool,
  showCardImages: PropTypes.bool,
  taxonomy: PropTypes.shape({})
});

_defineProperty(CompareCTA, "defaultProps", {
  analytics: {
    enabled: false
  },
  cardsToCompare: {},
  cardIDsToCompare: [],
  ctaText: {
    cta: 'Compare Cards',
    reset: 'Reset'
  },
  disableReset: false,
  numCardsToCompare: 0,
  showAddCard: false,
  showCardImages: false,
  taxonomy: {}
});

export { CompareCTA as default };
//# sourceMappingURL=compare-cta.js.map